const PageWrapper = ({ title, subtitle, icon: Icon, children }) => {
    return (
        <div className="max-w-3xl mx-auto space-y-4 text-gray-900 transition-colors dark:text-gray-100">
            {/* Header */}
            <div className="flex items-center gap-4">
                {Icon && (
                    <div className="flex items-center justify-center w-12 h-12 transition-colors rounded-xl dark:bg-primary/10 bg-primary-light/10 dark:text-primary text-primary-light">
                        <Icon className="w-6 h-6" />
                    </div>
                )}
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
                        {title}
                    </h1>
                    <p className="text-sm text-gray-600 opacity-70 dark:text-gray-400">
                        {subtitle}
                    </p>
                </div>
            </div>

            <div className="space-y-4">{children}</div>
        </div>
    );
};

export default PageWrapper;
